/** Available Fab Works logo options for in-app preview (screen UI only). */

export const DEFAULT_LOGO_ID = 'current';
export const LOGO_PREVIEW_KEY = 'wm_logo_preview';
export const THEME_DEFAULT_LOGO_IDS = {
  classic: DEFAULT_LOGO_ID,
  fabworks: 'v7-neon-navy',
};

export const LOGO_VARIANTS = [
  {
    id: 'current',
    label: 'Current (flat)',
    description: 'Existing production logos — color mark in the header, Georgia mark in the sidebar.',
    header: '/fabworks-logo-color.jpg',
    sidebar: '/fabworks-logo-bg.png',
    preview: '/fabworks-logo-color.jpg',
    plateOnDark: true,
  },
  {
    id: 'v1-clean-front',
    label: '3D Clean — Front',
    description: 'Extruded blue mark, front view, no stone base.',
    header: '/models/fabworks-logo-v1-clean-front.png',
    sidebar: '/models/fabworks-logo-v1-clean-front.png',
    preview: '/models/fabworks-logo-v1-clean-front.png',
    plateOnDark: true,
  },
  {
    id: 'v1-clean-angle',
    label: '3D Clean — Angle',
    description: 'Extruded blue mark at a three-quarter angle.',
    header: '/models/fabworks-logo-v1-clean-angle.png',
    sidebar: '/models/fabworks-logo-v1-clean-angle.png',
    preview: '/models/fabworks-logo-v1-clean-angle.png',
    plateOnDark: true,
  },
  {
    id: 'v2-granite-front',
    label: '3D Granite — Front',
    description: 'Blue extruded mark on Georgia granite, front view.',
    header: '/models/fabworks-logo-v2-granite-front.png',
    sidebar: '/models/fabworks-logo-v2-granite-front.png',
    preview: '/models/fabworks-logo-v2-granite-front.png',
    plateOnDark: true,
  },
  {
    id: 'v2-granite-angle',
    label: '3D Granite — Angle',
    description: 'Blue extruded mark on Georgia granite, angled studio render.',
    header: '/models/fabworks-logo-v2-granite-angle.png',
    sidebar: '/models/fabworks-logo-v2-granite-angle.png',
    preview: '/models/fabworks-logo-v2-granite-angle.png',
    plateOnDark: true,
  },
  {
    id: 'v3-granite-lavender-angle',
    label: '3D Granite — Lavender',
    description: 'Lavender-blue extruded mark on Georgia granite, angled studio render.',
    header: '/models/fabworks-logo-v3-granite-lavender-angle.png',
    sidebar: '/models/fabworks-logo-v3-granite-lavender-angle.png',
    preview: '/models/fabworks-logo-v3-granite-lavender-angle.png',
    plateOnDark: true,
  },
  {
    id: 'v4-neon-georgia',
    label: 'Neon Georgia',
    description: 'Electric neon blue mark with Georgia outline on dark charcoal.',
    header: '/models/fabworks-logo-v4-neon-georgia.png',
    sidebar: '/models/fabworks-logo-v4-neon-georgia.png',
    preview: '/models/fabworks-logo-v4-neon-georgia.png',
    // Already dark — skip the white plate so the charcoal field reads correctly.
    plateOnDark: false,
  },
  {
    id: 'v5-neon-cutout',
    label: 'Neon Georgia — Cutout',
    description: 'Electric blue Georgia mark with a transparent background for the sidebar.',
    header: '/models/fabworks-logo-v5-neon-cutout.png',
    sidebar: '/models/fabworks-logo-v5-neon-cutout.png',
    preview: '/models/fabworks-logo-v5-neon-cutout.png',
    plateOnDark: false,
  },
  {
    id: 'v6-granite-framed',
    label: '3D Granite — Framed',
    description: 'Lavender mark on Georgia granite inside a riveted metal frame.',
    header: '/models/fabworks-logo-v6-granite-framed.png',
    sidebar: '/models/fabworks-logo-v6-granite-framed.png',
    preview: '/models/fabworks-logo-v6-granite-framed.png',
    plateOnDark: false,
  },
  {
    id: 'v7-neon-navy',
    label: 'Neon Georgia — Navy',
    description: 'Electric blue Georgia mark on a solid navy field for the sidebar.',
    header: '/models/fabworks-logo-v7-neon-navy.png',
    sidebar: '/models/fabworks-logo-v7-neon-navy.png',
    preview: '/models/fabworks-logo-v7-neon-navy.png',
    plateOnDark: false,
  },
];

export const isValidLogoId = (id) => LOGO_VARIANTS.some((v) => v.id === id);

export const getLogoVariant = (id) =>
  LOGO_VARIANTS.find((v) => v.id === id) || LOGO_VARIANTS.find((v) => v.id === DEFAULT_LOGO_ID);

export const getThemeDefaultLogoId = (preset) =>
  THEME_DEFAULT_LOGO_IDS[preset] || DEFAULT_LOGO_ID;

export const readLogoPreviewId = () => {
  try {
    const value = window.localStorage.getItem(LOGO_PREVIEW_KEY);
    return isValidLogoId(value) ? value : null;
  } catch {
    return null;
  }
};

export const writeLogoPreviewId = (id) => {
  try {
    if (!id) window.localStorage.removeItem(LOGO_PREVIEW_KEY);
    else if (isValidLogoId(id)) window.localStorage.setItem(LOGO_PREVIEW_KEY, id);
  } catch {
    // ignore storage failures
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('wm-logo-preview-change'));
  }
};
